// API resources
import apiPortfolioBuilder from '@/api/modules/portfolio-builder'

// Mutations
import { RESET_MODULE, ADD_PORTFOLIOS_BUILDER_LIST } from '@/store/mutation-types'


// Default state
const getDefaultState = () => {
  return {
    list: [],
    filters: {}
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetchPortfolioBuilderVisible (context, bankContractId) {
    return apiPortfolioBuilder.fetchPortfolioBuilder({ status: 'visible', bankContractId })
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_PORTFOLIOS_BUILDER_LIST] (state, data) {
    state.list = data
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
